import React from "react";
import PrayerButtonGrid from "../components/PrayerButtonGrid";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


const categories = [
  "wisdom_prayer",
  "peace_prayer",
  "patience_prayer",
  "gratitude_prayer",
  "faith_prayer",
  "forgiveness_prayer",
  "guidance_prayer",
  "strength_prayer",
  "boyfriend",
  "girlfriend",
  "purpose_prayers",
  "anxiety_prayer",
  "dog_prayer",
  "cat_prayer"
];

function MorePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">More Prayers</h1>
      <PrayerButtonGrid
        categories={categories}
        onSelect={(cat) =>
          navigate(`/en/prayer/${cat}`, { state: { from: "/more" } })
        }
      />

      <div className="text-center mt-4">
        <Button className=" glass-button bg-transparent border-0" onClick={() => navigate("/en")}>Back to Home</Button>
      </div>
    </Container>
  );
}

export default MorePage;
